import {AbstractControl, ValidatorFn} from '@angular/forms';

/**
 * validator to check if password value is valid
 * @param password
 */
export function passwordValidator(password: AbstractControl): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value && control.value !== password.value) {
      return {passwordRepeat: true};
    }
    return null;
  };
}
